export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative min-h-screen w-full flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/073155b51f99ed9b5c69651f4a2b1921.jpg"
          alt="hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 pt-20">
        <div className="max-w-3xl">
          {/* Tag */}
          <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-4 py-1.5 mb-8">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse flex-shrink-0" />
            <span className="text-emerald-400 text-xs font-semibold tracking-widest uppercase whitespace-nowrap">iOS Application Development</span>
          </div>

          {/* Headline */}
          <h1 className="text-5xl xl:text-7xl font-extrabold text-white leading-[1.08] mb-6">
            Modern Apps<br />
            <span className="text-emerald-400">Built for</span><br />
            Your Security
          </h1>

          {/* Subtext */}
          <p className="text-white/60 text-lg xl:text-xl font-light leading-relaxed max-w-xl">
            IDEA D.O.O. crafts high-performance iOS applications that protect your privacy,
            optimize your device, and deliver a seamless mobile experience.
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce z-10">
        <span className="text-white/40 text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-px h-8 bg-gradient-to-b from-white/40 to-transparent" />
      </div>
    </section>
  );
}
